import { render, staticRenderFns } from "./RestaurantMarker.vue?vue&type=template&id=de8cc24a&"
import script from "./RestaurantMarker.vue?vue&type=script&lang=ts&"
export * from "./RestaurantMarker.vue?vue&type=script&lang=ts&"
import style0 from "./RestaurantMarker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports